/* eslint-disable no-magic-numbers */

import { EndUserConstants } from "../euscp/euscp";
import { EndUserKSP, getDefaultKSPs } from "./Models";
import { convertFromBase64, IS_DSTU_7564_DAY } from "./Utils";

/**
 * ПГУ GlSign
 */
export default class GlSign {
  /**
   * @param {string} value - Строковое представление параметра
   */
  constructor(value) {
    if (!value) {
      value = "";
    }
    const settingArray = value.split(";");
    this.AllowSavePassword = this._getZoneValue(settingArray, 1) !== "1";
    // AutoSetParam
    this.AutoSetParams = this._getSubZoneValue(settingArray, 2, ",", 1) === "+";
    // Provider
    this.ProviderName = this._getSubZoneValue(settingArray, 2, ",", 2);
    // SaveCert
    this.SaveCert = this._getZoneValue(settingArray, 3) === "+";
    // crl
    this.CheckCrls = this._getSubZoneValue(settingArray, 4, ",", 1) === "+";
    this.OwnCrlsOnly = this._getSubZoneValue(settingArray, 4, ",", 2) === "+";
    this.FullAndDeltaCrls = this._getSubZoneValue(settingArray, 4, ",", 3) === "+";
    this.AutoDownloadCrls = this._getSubZoneValue(settingArray, 4, ",", 4) === "+";
    // tsp
    this.UseTsp = this._getSubZoneValue(settingArray, 5, ",", 1) === "+";
    this.TspAddress = this._getSubZoneValue(settingArray, 5, ",", 2);
    this.TspPort = parseInt(this._getSubZoneValue(settingArray, 5, ",", 3));
    // ocsp
    this.UseOcsp = this._getSubZoneValue(settingArray, 6, ",", 1) === "+";
    this.OcspAddress = this._getSubZoneValue(settingArray, 6, ",", 2);
    this.OcspPort = parseInt(this._getSubZoneValue(settingArray, 6, ",", 3));
    this.OcspBeforeStore = this._getSubZoneValue(settingArray, 6, ",", 4) === "+";
    this.UseOcspAccess = this._getSubZoneValue(settingArray, 6, ",", 5) === "+";
    // cmp
    this.UseCmp = this._getSubZoneValue(settingArray, 7, ",", 1) === "+";
    this.CmpAddress = this._getSubZoneValue(settingArray, 7, ",", 2);
    this.CmpPort = parseInt(this._getSubZoneValue(settingArray, 7, ",", 3));
    // ldap
    this.UseLdap = this._getSubZoneValue(settingArray, 8, ",", 1) === "+";
    this.LdapAddress = this._getSubZoneValue(settingArray, 8, ",", 2);
    this.LdapPort = parseInt(this._getSubZoneValue(settingArray, 8, ",", 3));

    this.ValidateOwner = this._getZoneValue(settingArray, 9) === "+";
    this.StrongCheck = this._getZoneValue(settingArray, 10) === "+";
    this.DontEraseKey = this._getZoneValue(settingArray, 11) === "+";
    this.IdleTimeout = parseInt(this._getZoneValue(settingArray, 12));
    this.DeviceType = this._getZoneValue(settingArray, 13);
    this.MainCrl = this._getZoneValue(settingArray, 14);
    this.HashAlgorithm = this._getZoneValue(settingArray, 15);
    this.PreferHarware = this._getZoneValue(settingArray, 16);
    this.HideMobileId = true;

    this.UseProxy = this._getSubZoneValue(settingArray, 19, ",", 1) === "+";
    this.ProxyAddress = this._getSubZoneValue(settingArray, 19, ",", 2);
    this.ProxyPort = this._getSubZoneValue(settingArray, 19, ",", 3);
    this.ProxyUser = this._getSubZoneValue(settingArray, 19, ",", 4);
    this.ProxyPassword = this._getSubZoneValue(settingArray, 19, ",", 5);

    const applyProxySettings = this._getSubZoneValue(settingArray, 19, ",", 6);
    if (!applyProxySettings || !applyProxySettings.trim()) {
      this.ApplyProxySettings = this.UseProxy;
    }
    else {
      this.ApplyProxySettings = applyProxySettings === "+";
    }

    this.AllowTestKeys = this._getZoneValue(settingArray, 20) === "+";
    this.AgentSignWeb = this._getZoneValue(settingArray, 21) === "+";
    this.TestCAConnection = this._getZoneValue(settingArray, 22) === "+";
    this.DontSaveToRegistry = this._getZoneValue(settingArray, 23) === "+";

    let ksps = this._getZoneValue(settingArray, 24);

    const directAccess = this._getZoneValue(settingArray, 25) === "+" ? true : this._getZoneValue(settingArray, 25) === "-" ? false : null;
    this.DirectAccess = directAccess === true || directAccess !== false && !this.ApplyProxySettings && !this.UseProxy;

    this.PreLoadClientLibraries = this._getZoneValue(settingArray, 26) === "+";
    const fileSize = parseInt(this._getZoneValue(settingArray, 27));
    this.WebClientFileSize = fileSize < 5 ? 5 : fileSize > 127 ? 127 : fileSize;
    this.UseTSL = this._getZoneValue(settingArray, 28) === "+";
    this.UmcaservicePort = this._getZoneValue(settingArray, 29);

    if (!ksps) {
      this.KSPs = getDefaultKSPs(this.AllowTestKeys);
    } else {
      try {
        ksps = convertFromBase64(ksps);
        this.KSPs = JSON.parse(ksps);
      } catch (error) {
        console.error("error parsing KSPs from GlSign");
        console.error(error);
      }

      if (!this.KSPs || this.KSPs.length === 0)
      {
        this.KSPs = getDefaultKSPs(this.AllowTestKeys);
      }

      this.KSPs.forEach(element => {
        if (element.ksp === EndUserKSP.DIIA || element.ksp === EndUserKSP.IIT || element.ksp === EndUserKSP.PB || element.ksp === EndUserKSP.VTOKEN) {
          if (element.address.includes("cabinet.e-life.com.ua")
            || element.address.includes("sserver.amokey.com")
            || element.address.includes("smart-sign.dpsu.gov.ua")
            || element.address.includes("sign-ca.mvs.gov.ua")
            || element.address.includes("id.edin.ua")
            || element.address.includes("business.ukrsibbank.com")) {
            return;
          }
          if (!Array.isArray(element.signAlgos) || element.signAlgos.length == 0) {
            element.signAlgos = [ EndUserConstants.EndUserSignAlgo.DSTU4145WithDSTU7564, EndUserConstants.EndUserSignAlgo.DSTU4145WithGOST34311 ];
          }
        }
        // if (element.ksp === EU_KSP_GRYADA) {
        //   element.signAlgos = this.HashAlgorithm !== "GOST34311" ? [ EndUserSignAlgo.DSTU4145WithDSTU7564 ] : [ EndUserSignAlgo.DSTU4145WithGOST34311 ];
        // }
      });
    }
  }
  _getZoneValue(zones, zone) {
    if (zones.length >= zone) {
      const zoneValue = zones[zone - 1];
      return zoneValue ? zoneValue : "";
    }
    return "";
  }
  _getSubZoneValue(zones, zone, separator, subzone) {
    const zoneValue = this._getZoneValue(zones, zone);
    if (!zoneValue) {
      return "";
    }
    const subZones = zoneValue.split(separator);
    return this._getZoneValue(subZones, subzone);
  }
}
